module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/star-5652637dbb9b074f75c1b550cb4ae1f0.svg";